import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function Header() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-xl font-bold">F1 Predictor</Link>
        
        <nav>
           <ul className="flex space-x-4 list-none items-center">
            <li><Link to="/" className="text-white">Home</Link></li>
            <li><Link to="/predictions" className="text-white">Predictions</Link></li>
            <li><Link to="/leaderboard" className="text-white">Leaderboard</Link></li>
            <li><Link to="/results" className="text-white">Results</Link></li>
            <li><Link to="/roadmap" className="text-white">Roadmap</Link></li>
            
            {user ? (
              <>
                <li className="text-gray-400">Welcome, {user.username}</li>
                <li>
                  <button 
                    onClick={handleLogout}
                    className="text-white"
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li><Link to="/login" className="text-white">Login</Link></li>
                <li><Link to="/register" className="text-white">Register</Link></li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;